import React from "react";

import { FullPageNotionEmbed, Header } from "src/shared/components";

const NOTION_PAGE_URL =
  "https://hackthenorth.notion.site/ebd/3c0b70e03de780ffa66af292e8ded6cf";

export const Prizehub: React.FC = () => (
  <>
    <Header title="Prizehub" subtitle="Check out the awesome prizes we have!" />
    <FullPageNotionEmbed url={NOTION_PAGE_URL} title="Prizehub Notion page" />
  </>
);
